module.exports = __webpack_public_path__ + "img/ezgif.com-apng-maker-7.cb4e29d7.png";